/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import ContentWrapper from "ui/common/ContentWrapper";
import Header1 from "ui/kit/typography/Header1";
import Body from "ui/kit/typography/Body";
import {QueryRenderer} from "react-relay";
import environment from "constants/environment";
import query from "./LibraryQuery"
import ErrorSection from "ui/common/ErrorSection";
import LoadingSection from "ui/common/LoadingSection";
import {LibraryQuery} from "./__generated__/LibraryQuery.graphql";
import styles from "./Library.module.scss";
import LibraryRows from "ui/feature/library/LibraryRows";

const Library: React.FC = () => {

    return (
        <ContentWrapper className={styles.contentWrapper}>
            <Header1>Library</Header1>
            <Body>View all of your music pieces</Body>
            <QueryRenderer<LibraryQuery>
                environment={environment}
                query={query}
                variables={{}}
                render={({props, error}) => {
                    if (error) {
                        return <ErrorSection/>;
                    } else if (props) {
                        return <LibraryRows musicViewer={props.music_viewer}/>;
                    } else {
                        return <LoadingSection/>;
                    }
                }}
            />
        </ContentWrapper>
    )
}

export default Library;